module.exports = _mano_registry["styled-components"];